<template>
  <div class="courses-list-section">
    <!-- 2 图文 -->
    <!-- -->
    <van-row v-if="dataItem" class="courses-list-section-box" @click="go_course(dataItem)">
      <van-col class="courses-list-section-left">
        <van-image
            v-if="dataItem.content.cover_img"
            fit="cover"
            class="courses-list-content-imgs"
            :src="dataItem.content.cover_img"
            width="100%"
            height="73"
        />
        <div class="courses-list-section-left-top" v-if="dataItem.top == 1">
          <img src="/static/bytx/tag_top.svg" alt=""/>
        </div>
        <div class="courses-list-section-left-zl" v-else-if="dataItem.type == 2">
<!--          <img src="/static/two/icon_list_tag_subject_text.svg" alt=""/>-->
        </div>
        <!-- <div class="courses-list-section-left-zl" v-else>
            精彩图文
        </div> -->
      </van-col>

      <van-col class="courses-list-content">
        <div class="courses-list-title" v-html="dataItem.content.title">
        </div>
        <!-- <div class="courses-lis-desc">
            {{ dataItem.desc }}
        </div> -->
        <div class="courses-list-content-detail">
          <div v-if="dataItem.content.type != 2">
            <span>{{ dataItem.content.created_at.substr(0,10)}}</span>
            <span>{{ dataItem.content.view_count }}人阅读</span>
          </div>
          <div v-else>共{{ dataItem.content.total_count ? dataItem.content.total_count : dataItem.content.course_count }}节 {{ dataItem.content.view_count }}人观看</div>
        </div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import Interface from "../../../util/interface";

export default {
  name: "course",
  props: {
    dataItem: {
      type: Object,
      required: true
    },
    contentItem: {
      type: Object
    },
    wapperFn: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    go_course(row) {

        if(row.content.origin_type == 4){
            Interface.goLiveDetail(this,{
                type:row.content.type,
                id:row.content.origin_id,
                live_status: row.content.live_status,
            })
        }else{
            if (row.content.type == 2) {
                this.$router.push({ name: 'course-column', params: { id: row.origin_id } })
            } else {
                this.$router.push({ name: 'course-detail', params: { id: row.origin_id } })
            }
        }
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/components/variable.scss';

.courses-list-section {
  // border-bottom: 1px solid #f2f2f2;
  padding: 10px 0 10px 0;
  background-color: #ffffff;
  margin: 10px 10px;
  border-radius: 10px 10px 10px 10px;
  padding-left: 10px;
  border-bottom: 1px solid #f2f2f2;

  .courses-list-title {
    font-family: PingFangSC-Medium, PingFang SC;
    font-size: 14px;
    font-weight: 500;
    color: #222222;
    text-align: justify;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /deep/ .light {
      color: #D81D20;
    }
  }

  .courses-list-content {
    text-align: left;
    position: relative;
    height: 80px;
    // padding-left: 12px;
    // padding-right: 15px;

    &-desc {
      margin-top: 9px;
      font-size: 14px;
      color: $desc-color;
      text-align: justify;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      word-break: break-all;
      overflow: hidden;
    }

    &-detail {
      margin-top: 10px;
      width: 100%;
      font-family: PingFangSC-Regular;
      font-size: 12px;
      color: #9d9d9d;
      letter-spacing: 0;

      .float-right {
        float: right;
        padding-right: $font16;
      }

      div {
        display: inline-block;
      }
    }

    &-img {
      width: 130px;
      height: 71px;
      border-radius: 6px;

      > > > .van-image__img {
        border-radius: 6px;
      }

      img {
        width: 130px;
        border-radius: 6px;
      }
    }
  }

  &-box {
    &:after {
      padding-top: 20px;
      width: 100%;
      height: 1px;
      border-bottom: 1px solid #e8e8e8;
      content: ' ';
      margin-bottom: 20px;
    }

    &:last-child:after {
      border: 0;
    }

    position: relative;
  }

  .courses-list-section-left-zl {
    position: absolute;
    left: 0px;
    top: 0px;
    border-radius: 3px;

    &.active {
      background-image: linear-gradient(135deg, #ffa3af 0%, #ff555e 100%);
      border-radius: 6px 3px 3px 3px;
    }
  }

  .courses-list-section-left {
    width: 130px;
    border-radius: 6px;
    margin-right: 10px;
  }

  .courses-list-content {
    width: 193px;
    height: 68px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .courses-list-content-imgs {
    border-radius: 6px;

    /deep/ .van-image__img {
      width: 130px;
      height: 71px;
      border-radius: 6px;
    }
  }

  .courses-list-section-left-top {
    position: absolute;
    top: 4px;
    left: 4px;
    width: 18px;
    height: 18px;
    border-radius: 3px;

    img {
      width: 18px;
      height: 18px;
      border-radius: 3px;
    }
  }

  .courses-list-section-box:after {
    padding-top: 0;
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/course.vue